module.exports = __webpack_public_path__ + "assets/img/dzh-12.82edb683.jpg";